<template>
    <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      :retain-focus="false"
      content-class="bottom-sheet"
    >
    <v-card>
      <v-card-title>
        여행지원서를 작성해주세요!
      </v-card-title>
      <v-card-text>
        <v-img :src="getImage('ic_examine.svg')" width="70px" class="my-3 mx-auto" />
        <p class="text-center fs-lg">
          <b>검사를 진행한 지 3개월이 지났습니다.</b><br />
          현재 심리상태에 대한 정확한 결과 확인을 위해<br />
          다시 작성해보세요.
        </p>
      </v-card-text>
      <v-card-actions>
        <div class="btn-group">
          <v-btn color="primary" class="btn-basic"
                 x-large depressed
                 @click="applRetry"
          >
            재검사하기
          </v-btn>
          <v-btn x-large depressed
                 @click="next"
          >
            <span class="fs-md">3개월 뒤 검사 알림받기</span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
    </v-bottom-sheet>
</template>
<script>

import store from '@/store'

export default {
  props: {
    sheet: Boolean,
  },
    data: ()=> ({
    }),
  computed:{
  },
  components: {
  },
  methods: {
      next() {
          this.setTravelapplAlarmDt();
      },
      applRetry() {
          this.$router.push({ name: "travelIntro", query: { travelApplStepCd: "0001", startType: 'R' } });
          this.$emit('sheetClose');
      },
      async setTravelapplAlarmDt () {
      await store.dispatch('setTravelapplAlarmDt')
          .then(res => {
            if (res.success) {
              this.$emit('sheetClose');
            } else {
              console.log(res.msg);
            }
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {})
    },
  },
};
</script>
